import { Site } from '../models';
import { Site as SiteEntity } from 'adc-sirius-module-common';
import { uuidv4 } from '../utilities/adc';
import { urls } from '../utilities/dataHelpers';
import { mapSiteEntityToSite, mapSiteToSiteEntity } from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';

const handleGetSitesByStudy = (
  request: MediatorRequestWithResponse<Site[]>,
) => {
  const studyKey = request.studyKey;
  const state = request.state;

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SiteEntity[]>('api:invoke', {
        method: 'GET',
        url: `${urls.api}sites/study/${studyKey}`,
        queryString: state ? `?rowstate=${state}` : '',
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(
            (result.data ?? []).map((siteEntity) =>
              mapSiteEntityToSite(siteEntity),
            ),
          );
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching sites:', err);
        reject(err);
      });
  });
};

const handleGetSiteByKey = (request: MediatorRequestWithResponse<Site>) => {
  request.response = new Promise((resolve, reject) => {
    const siteKey = request.key;

    mediator
      .request<SiteEntity>('api:invoke', {
        method: 'GET',
        url: `${urls.api}sites/${siteKey}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSiteEntityToSite(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching site by ID:', err);
        reject(err);
      });
  });
};

const handleCreateSite = (request: MediatorRequestWithResponse<Site>) => {
  request.data.key = uuidv4();
  const siteEntity = mapSiteToSiteEntity(request.data);

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SiteEntity>('api:invoke', {
        method: 'POST',
        url: urls.api + 'sites',
        data: siteEntity,
      })
      .then((result) => {
        if (result.status === 201) {
          resolve(mapSiteEntityToSite(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error creating site:', err);
        reject(err);
      });
  });
};

const handleUpdateSite = (request: MediatorRequestWithResponse<Site>) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SiteEntity>('api:invoke', {
        method: 'PUT',
        url: `${urls.api}sites`,
        data: mapSiteToSiteEntity(request.data),
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSiteEntityToSite(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error updating site:', err);
        reject(err);
      });
  });
};

mediator.subscribe('site:getSites', handleGetSitesByStudy);
mediator.subscribe('site:getSiteByKey', handleGetSiteByKey);
mediator.subscribe('site:createSite', handleCreateSite);
mediator.subscribe('site:updateSite', handleUpdateSite);
